import { action, computed, makeObservable, observable } from 'mobx';

import { Store } from '../../store/store';
import { StoreNode } from '../../store';
import { JobModel } from '../../entities';

export class DocumentPageState extends StoreNode {

  constructor(store: Store) {
    super(store);
    makeObservable(this);
  }

  @observable jobId: string | null = null;
  @observable isLoading = false;
  @observable error: string | null = null;
  @observable teamId: string | null = null;

  @computed
  get job(): JobModel | null {
    if (!this.jobId)
      return null;
    return this.store.jobManager.maybeGetJob(this.jobId);
  }

  @action
  async mounted(jobId: string, teamId?: string) {
    this.jobId = jobId;
    this.teamId = teamId ?? null;
    this.isLoading = true;
    this.error = null;
    this.store.documentUploadGuidedTraining.handleDocumentPageMounted(jobId);

    const [, err] = await this.store.apiFetchJob(jobId);
    if (err) {
      this.error = 'Failed to load job.';
    }

    this.isLoading = false;
  }

  @action
  unmounted() {
    this.store.documentUploadGuidedTraining.handleDocumentPageUnmounted();
    this.jobId = null;
    this.isLoading = false;
    this.error = null;
    this.teamId = null;
  }
}
